export default {
      id: "arrow-down-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }